var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.5C0.5 1.85938 1.8125 0.5 3.5 0.5H21.5C23.1406 0.5 24.5 1.85938 24.5 3.5V15.5C24.5 17.1875 23.1406 18.5 21.5 18.5H3.5C1.8125 18.5 0.5 17.1875 0.5 15.5V3.5ZM2.75 3.5V4.57812L10.8125 11.1875C11.7969 11.9844 13.1562 11.9844 14.1406 11.1875L22.25 4.57812V3.5C22.25 3.125 21.875 2.75 21.5 2.75H3.5C3.07812 2.75 2.75 3.125 2.75 3.5ZM2.75 7.48438V15.5C2.75 15.9219 3.07812 16.25 3.5 16.25H21.5C21.875 16.25 22.25 15.9219 22.25 15.5V7.48438L15.5938 12.9219C13.7656 14.4219 11.1875 14.4219 9.35938 12.9219L2.75 7.48438Z",
    fill: "url(#paint0_linear_1905_1481)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1905_1481",
    x1: 12.5,
    y1: -2.5,
    x2: 12.5,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E66FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E66FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.9a481cf4490b1ecbe39a532a81d8f0b3.svg";
export { ForwardRef as ReactComponent };